import { Box, Stack } from '@mui/material'

import FeedTableIcon from 'assets/FeedTableIcon'
import { BaseWidget } from 'components/farm-dashboard/components/widgets/baseWidget'
import { roundingNumber } from 'components/shared/processes'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { PsvAvg } from 'models/IFarm'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'

export const PsvWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()
	const psv = statistics?.psv_avg as PsvAvg
	const value = psv?.total != null ? roundingNumber(psv.total, 3) : null
	if (!permissions?.license_food_table || error) return null

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<FeedTableIcon color={COLORS.main} width={16} height={16} />
				</Box>
			}
			path={'/feed/'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					<TypographyPrimary16Bold>
						{value ? value.toLocaleString() : 'Нет данных'}
					</TypographyPrimary16Bold>
				</Stack>
				<TypographyPrimary>Потребление сухого вещества</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
